import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Motherboards() {
  const [motherboards, setMotherboards] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем по категории "motherboard"
        const motherboardItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'motherboard'
        );

        setMotherboards(motherboardItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="motherboards">
      <h1>Материнские платы</h1>
      <div className="motherboards__list">
        {motherboards.length > 0 ? (
          motherboards.map((mb) => (
            <div key={mb.id} className="motherboards__card">
              <img src={mb.image} alt={mb.name} />
              <h2>{mb.name}</h2>
              <p className="specs">{mb.description}</p>
              <p className="price">{mb.price}</p>
              <Link to={`/components/motherboards/${mb.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
